import { mutator } from 'satcheljs';
import getMailboxRootFolder from '../selectors/getMailboxRootFolder';
import { setRootFolderDisplayNameForMailbox } from '../actions/internalActions';

/**
 * Mutator that sets the root folder's display name.
 */
export default mutator(setRootFolderDisplayNameForMailbox, actionMessage => {
    let rootFolder = getMailboxRootFolder(actionMessage.mailboxId);
    rootFolder.DisplayName = actionMessage.displayName;
});
